import { render, staticRenderFns } from "./vat-reports.vue?vue&type=template&id=becb523c"
import script from "./vat-reports.vue?vue&type=script&lang=js"
export * from "./vat-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports